import React from 'react';
import PropTypes from 'prop-types';

class IntegerInLimits extends React.PureComponent {
  static propTypes = {
    children: PropTypes.object,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    min: PropTypes.number,
    max: PropTypes.number,
  };

  constructor(props) {
    super(props);
    const { min, max } = props;
    this.errorMessage = `Value must be between ${min} - ${max}`;
  }

  handleKeyPress = (event) => {
    if (!'-0123456789'.includes(event.key)) {
      event.preventDefault();
    }
  }

  handleBlur = (e) => {
    this.handleChange(e, { name: e.target.name, value: e.target.value });
  }

  handleChange = (event, props) => {
    const { min, max, onChange } = this.props;
    const { value } = props;

    if (!value || value === '-') {
      onChange(event, {
        ...props,
        isInvalid: false,
        error: null,
      });
    } else {
      const parsed = parseInt(value, 10);
      /* istambul ignore else */
      if (!Number.isNaN(parsed)) {
        if (parsed <= max) {
          onChange(event, {
            ...props,
            parsed,
            value,
            isInvalid: false,
            error: (parsed < min) ? this.errorMessage: null,
          });
        } else {
          onChange(event, {
            ...props,
            parsed,
            value,
            isInvalid: true,
            error: this.errorMessage,
          });
        }
      }
    }
  }

  render() {
    const { children } = this.props;
    return React.Children.map(children, (child) => (
      React.cloneElement(child, {
        onKeyPress: this.handleKeyPress,
        onChange: this.handleChange,
        onBlur: this.handleBlur,
      })
    ));
  }
}

export default IntegerInLimits;
